import api from './api';

export interface CreateIdentityDisclosureRequest {
  recipientUsername: string;
  requestIdentityPhotos: boolean;
  requestMailingAddress: boolean;
}

export interface CreateIdentityDisclosureResponse {
  requestId: string;
  chargedAmount: number;
  status: string;
  recipientUsername: string;
  createdAtUtc: string;
}

export interface IdentityDisclosureEvidence {
  verifiedFullName?: string;
  idState?: string;
  idCountry?: string;
  portraitImageUrl?: string;
  livenessVideoUrl?: string;
  mailingAddressLine1?: string;
  mailingAddressLine2?: string;
  mailingCity?: string;
  mailingState?: string;
  mailingPostalCode?: string;
  mailingCountryCode?: string;
}

export interface IdentityDisclosureRequestDetails {
  requestId: string;
  status: string;
  createdAtUtc: string;
  recipientViewedAtUtc?: string;
  decisionAtUtc?: string;
  requestIdentityPhotos: boolean;
  requestMailingAddress: boolean;
  feeAmount: number;
  requesterUsername: string;
  requesterDisplayName: string;
  recipientUsername: string;
  decisionNotes?: string;
  canDecide: boolean;
  isRequesterView: boolean;
  evidence?: IdentityDisclosureEvidence;
}

export interface IdentityDisclosureDecisionRequest {
  approve: boolean;
  notes?: string;
}

export interface IdentityDisclosurePreference {
  autoApproveAllRequests: boolean;
}

export interface IdentityDisclosureShieldSnapshot {
  recipientUsername: string;
  approvedAtUtc: string;
  requestId: string;
  requestIdentityPhotos: boolean;
  requestMailingAddress: boolean;
  evidence: IdentityDisclosureEvidence;
}

const identityDisclosureService = {
  listMyRequests: () =>
    api.get<IdentityDisclosureRequestDetails[]>('/api/IdentityDisclosure/requests/me'),

  createRequest: (request: CreateIdentityDisclosureRequest) =>
    api.post<CreateIdentityDisclosureResponse>('/api/IdentityDisclosure/requests', request),

  getRequest: (requestId: string) =>
    api.get<IdentityDisclosureRequestDetails>(`/api/IdentityDisclosure/requests/${requestId}`),

  decide: (requestId: string, request: IdentityDisclosureDecisionRequest) =>
    api.post<IdentityDisclosureRequestDetails>(`/api/IdentityDisclosure/requests/${requestId}/decision`, request),

  getPreferences: () =>
    api.get<IdentityDisclosurePreference>('/api/IdentityDisclosure/preferences'),

  updatePreferences: (request: IdentityDisclosurePreference) =>
    api.put<IdentityDisclosurePreference>('/api/IdentityDisclosure/preferences', request),

  getShieldSnapshot: (recipientUsername: string) =>
    api.get<IdentityDisclosureShieldSnapshot>(`/api/IdentityDisclosure/shield/${encodeURIComponent(recipientUsername)}`),

  getMyVerificationPreview: () =>
    api.get<IdentityDisclosureEvidence>('/api/IdentityDisclosure/preview/me')
};

export default identityDisclosureService;
